import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { UploadPhotoComponent } from '../../../photo/upload-photo/upload-photo.component';

@Component({
  selector: 'app-auth-subscribe-fourth',
  standalone: true,
  imports: [UploadPhotoComponent, RouterModule],
  templateUrl: './auth-subscribe-fourth.component.html',
  styleUrl: './auth-subscribe-fourth.component.scss'
})
export class AuthSubscribeFourthComponent {
  flow = 'subscription'

  hightlightedSteps: {
    first: boolean, 
    second?: boolean, 
    third?: boolean, 
    fourth?: boolean
  } = { first: true, second: true, third: true, fourth: true }
}
